import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Overview from '@/components/Overview'
import Users from '@/components/Users'
import Training from '@/components/Training'
import Auth from '../auth'
import Count from '@/components/Count'
import TeamDashboard from '@/components/TeamDashboard'
import PixelTest from '@/components/PixelTest'
import ViewTest from '@/components/PixelTest/ViewTest'
import Promos from '@/components/Promos'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Overview',
      component: Overview,
      meta: { auth: true }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: { auth: true }
    },
    {
      path: '/users/:id',
      name: 'Users',
      component: Users,
      meta: { auth: true }
    },
    {
      path: '/training',
      name: 'Training',
      component: Training,
      meta: { auth: true }
    },
    {
      path: '/promos',
      name: 'Promos',
      component: Promos,
      meta: { auth: true }
    },
    {
      path: '/promos/:id',
      name: 'EditPromo',
      component: Promos,
      meta: { auth: true }
    },
    {
      path: '/training/:id',
      name: 'Edit Lesson',
      component: Training,
      meta: { auth: true }
    },
    {
      path: '/count',
      name: 'Count',
      component: Count
    },
    {
      path: '/team-dashboard',
      name: 'Team Dashboard',
      component: TeamDashboard,
      meta: { auth: true }
    },
    {
      path: '/pixel-test',
      name: 'Pixel Test',
      component: PixelTest,
      meta: { auth: true }
    },
    {
      path: '/view-test',
      name: 'View Test',
      component: ViewTest,
      meta: { auth: true }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // To simulate "scroll to anchor" behavior:
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 10 }
      }
    }
    // native-like scroll behavior when navigating with back/forward (scroll to saved position)
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// Handle Authenticated Routes
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth) && !Auth.isSignedIn()) {
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js